  <svg class="em-c-icon" [ngClass]="innerClass" [style]="innerStyle"
       [class.em-c-icon--xsmall]="size === 'extraSmall'" [class.em-c-icon--small]="size === 'small'" [class.em-c-icon--medium]="size === 'medium'" [class.em-c-icon--large]="size === 'large'"
       [class.em-c-tooltip__icon]="tooltipIcon"
       [class.warning-color]="useWarningColor" [style.color]="color">
    <use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.xlink:href]="'unity/images/' + sizeFolder + 'em-icons.svg#' + icon"></use>
  </svg>
